import { styled } from '@linaria/react'
import { IconSC } from 'atoms/Icon'
import { TextBoxSC } from 'atoms/TextBox'
import { FIXED_INDENTS, MEDIA } from 'vars/index'
import { Button } from '../Button'

export const DetailsSecondaryOpacityButtonSC = styled(Button)`
  &[data-arcana-button='true'] {
    padding: var(${FIXED_INDENTS.INDENT_30}) var(${FIXED_INDENTS.INDENT_30})
      var(${FIXED_INDENTS.INDENT_30}) var(${FIXED_INDENTS.INDENT_30});
    min-width: 0;

    ${TextBoxSC} {
      display: none;
    }

    ${MEDIA.MIN_600} {
      padding: var(${FIXED_INDENTS.INDENT_30}) var(${FIXED_INDENTS.INDENT_100});
      min-width: 132px;

      ${TextBoxSC} {
        display: block;
      }

      ${IconSC} {
        display: none;
      }
    }
  }
`
